import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

// A slow, editorial oversized marquee that drifts opposite to scroll direction.
export default function EditorialMarquee() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const x = useTransform(scrollYProgress, [0, 1], ["2%", "-18%"]);

  const words = ["No Results.", "No Pay.", "Revenue Rescued.", "Period."];

  return (
    <section
      ref={ref}
      data-testid="editorial-marquee"
      className="relative py-14 lg:py-20 border-y border-white/10 bg-[#050505] overflow-hidden"
    >
      <motion.div
        style={{ x }}
        className="flex items-center gap-8 whitespace-nowrap will-change-transform"
      >
        {[...words, ...words, ...words].map((w, i) => (
          <span key={i} className="flex items-center gap-8">
            <span
              className={`font-display text-6xl sm:text-8xl lg:text-[140px] uppercase leading-none ${
                i % 2 === 0
                  ? "text-white/90"
                  : "text-transparent [-webkit-text-stroke:1.5px_rgba(255,255,255,0.25)]"
              }`}
            >
              {w}
            </span>
            <span className="w-3 h-3 lg:w-5 lg:h-5 bg-[#ccff00] shrink-0 rotate-45" />
          </span>
        ))}
      </motion.div>
    </section>
  );
}
